import { toast } from "react-toastify";

import UserService from "Services/user";

export const CREATE_PROFILE_REQUESTED = "CREATE_PROFILE_REQUESTED";
export const CREATE_PROFILE_OK = "CREATE_PROFILE_OK";
export const CREATE_PROFILE_FAIL = "CREATE_PROFILE_FAIL";

export const SET_ACCOUNT_TYPE = "SET_ACCOUNT_TYPE";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_PROFILE = "SET_PROFILE";

export const TOGGLE_TERMS_MODAL = "TOGGLE_TERMS_MODAL";

export const SET_REF_ID = "SET_REF_ID";

export function create(data, externalData) {
  const { data: user } = data;
  return (dispatch) => {
    dispatch({ type: CREATE_PROFILE_REQUESTED });

    UserService.create(user, externalData)
      .then((responseData) => {
        dispatch({
          type: CREATE_PROFILE_OK,
          data: responseData,
        });
      })
      .catch((errors) => {
        if (errors.captcha) {
          toast.error(`Captcha: ${errors.captcha[0]}`);
        }

        dispatch({
          type: CREATE_PROFILE_FAIL,
          errors,
        });
      });
  };
}

export function set(data) {
  return {
    type: SET_PROFILE,
    data,
  };
}

export function setAccountType(data) {
  return {
    type: SET_ACCOUNT_TYPE,
    data,
  };
}

export function setCountry(country) {
  return {
    type: SET_COUNTRY,
    country,
  };
}

export function setRefId(refId) {
  return {
    type: SET_REF_ID,
    refId,
  };
}

export function toggleTermModal(currentPosition) {
  return {
    type: TOGGLE_TERMS_MODAL,
    currentPosition,
  };
}
